import type { LeadFlow } from '@/data'
import api from '..'
import { buildFlowFormData, type LeadFlowPayload } from './createFlow'

export async function updateFlow(
  id: string,
  payload: LeadFlowPayload,
): Promise<LeadFlow> {
  const fd = buildFlowFormData(payload)
  const res = await api.put(`/flows/${id}`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return res.data.data
}
